import get from 'lodash/get'
import {createGlobalStyle} from 'styled-components'
import styledNormalize from 'styled-normalize'

const GlobalStyle = createGlobalStyle`
   ${styledNormalize}

  body {
    font-family: ${props => props.theme.font.family};
    font-weight: ${props => props.theme.font.fontWeight};
    color: ${props => props.theme.font.color.dark};
    background-color: ${props => get(props.theme, 'shell.body.backgroundColor')};
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
     color: ${props => props.theme.font.color.dark};
  }

  html {
    font-size:  ${props => props.theme.font.size};
    line-height: ${props => props.theme.font.height};
  }

   @media (min-width: ${props => props.theme.breakpoints.mobile}px){
      html {
        font-size:  ${props => props.theme.font.mobile.size};
        line-height: ${props => props.theme.font.mobile.height};
      }
   }

   @media (min-width: ${props => props.theme.breakpoints.portrait}px){
      html {
        font-size:  ${props => props.theme.font.portrait.size};
        line-height: ${props => props.theme.font.portrait.height};
      }
   }

   @media (prefers-color-scheme: dark) {
     body {
       background-color: ${props => get(props.theme, 'shell.body.backgroundColor', '#ffffff')};
     }
   }
`

export default GlobalStyle
